import { useCallback } from 'react';
import { SdkErrorResponse } from 'src/utilities/notifications';
import { IErrorResponse } from 'src/utilities/shared-types';
import { Employee } from 'src/types/Employee';
import { updateEmployee } from 'src/components/enterprise/features/Employee/EditPage/api/updateEmployeeAPI';
import { extendEmployeeModel } from 'src/components/enterprise/features/Employee/utils/employee.utils';

export type UseUpdateEmployeeProps = {
  corpId: string;
  employeeId: string;
  employeeRawData: Employee;
  onSuccess: (employee: Employee) => Promise<void>;
  onError: (error: IErrorResponse | SdkErrorResponse) => Promise<void>;
};

export type UseUpdateEmployeeReturnType = {
  updateEmployee: (values: Employee) => Promise<void>;
};

export const useUpdateEmployee = ({
  corpId,
  employeeId,
  employeeRawData,
  onSuccess,
  onError,
}: UseUpdateEmployeeProps): UseUpdateEmployeeReturnType => {
  const updateEmployeeTrigger = useCallback(
    async (values: Employee) => {
      const employeePayload = extendEmployeeModel(values, employeeRawData);
      try {
        await updateEmployee(corpId, employeeId, employeePayload);
        await onSuccess({ ...employeePayload, id: employeeId });
      } catch (error) {
        await onError(error);
      }
    },
    [corpId, employeeId, onSuccess, onError, employeeRawData]
  );

  return {
    updateEmployee: updateEmployeeTrigger,
  };
};
